import { render } from "./ProjectBaseView.vue?vue&type=template&id=09828ffe"
import script from "./ProjectBaseView.vue?vue&type=script&lang=js"
export * from "./ProjectBaseView.vue?vue&type=script&lang=js"

import "./ProjectBaseView.vue?vue&type=style&index=0&id=09828ffe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__